import { useEffect } from "react";
import { useLocation } from "react-router";
import { useMe } from "./useMe";

const ROUTE_TITLES: Record<string, string> = {
  "/profile": "Profile",
  "/dashboard": "Dashboard",
  "/notifications": "Notifications",
  "/system/dashboard": "System Dashboard",
  "/streaming/dashboard": "Streaming Dashboard",
  "/settings/general": "General Settings",
  "/settings/email": "Email Settings",
  "/settings/notifications": "Notification Settings",
  "/settings/sessions": "Session Settings",
  "/settings/security": "Security Settings",
  "/settings/registration": "Registration Settings",
  "/users/registration": "User Registration",
  "/users/admin": "User Admin",
  "/users/groups": "User Groups",
  "/users/roles": "User Roles",
  "/system/console": "Web Console",
  "/system/api": "API Playground",
  "/system/ssl": "SSL Control",
  "/system/vpn": "VPN Control",
  "/system/changelog": "Changelog",
  "/system/news": "News",
  "/system/logs": "System Logs",
  "/system/audit-log": "Audit Log",
  "/system/app-templates": "App Templates",
  "/content/media": "Asset Management Center",
};

export const usePageTitle = () => {
  const { appConfig } = useMe();
  const location = useLocation();
  const instanceName = appConfig?.instanceName || "QuickBox Pro";

  useEffect(() => {
    const pageTitle = ROUTE_TITLES[location.pathname];
    document.title = pageTitle
      ? `${pageTitle} \u2014 ${instanceName}`
      : instanceName;
  }, [location.pathname, instanceName]);
};
